export const Top2 = () => {
    return (
        <svg width="144" height="175" viewBox="0 0 144 175" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M115.407 150.012L111.913 172.308H1.51349L4.65778 152.102L66.379 92.9955C70.3384 89.2021 74.492 85.0217 78.8397 80.4541C83.265 75.8866 87.1468 71.0095 90.4852 65.8226C93.9012 60.6358 96.0362 55.1393 96.8902 49.3331C97.4337 44.6882 97.0843 40.3916 95.8421 36.4434C94.5999 32.4952 92.3873 29.2825 89.2042 26.8052C86.0987 24.3279 81.9839 23.0505 76.8599 22.9731C70.5713 22.7409 65.1368 24.0569 60.5562 26.9213C56.0533 29.7857 52.4432 33.6565 49.7259 38.5336C47.0862 43.4108 45.3782 48.7525 44.6019 54.5587L17.4678 54.6748C18.3218 43.914 21.5438 34.4693 27.1336 26.3407C32.8011 18.1346 40.0989 11.7866 49.0272 7.29647C58.033 2.80637 67.8929 0.638738 78.6067 0.793569C87.8455 0.9484 96.1138 2.80637 103.412 6.36749C110.71 9.9286 116.338 15.1154 120.298 21.928C124.257 28.7406 125.81 36.9853 124.956 46.6623C124.412 53.1652 122.743 59.3197 119.948 65.1259C117.153 70.932 113.66 76.4672 109.467 81.7315C105.353 86.9183 100.927 91.8342 96.1915 96.4792C91.4556 101.124 86.8751 105.537 82.4498 109.717L40.1766 150.012H115.407Z"
                fill="url(#paint0_linear_1274_445)"
                fillOpacity="0.4"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_1274_445"
                    x1="1.51349"
                    y1="81.0287"
                    x2="144.836"
                    y2="81.0287"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="0.763542" stopColor="white" stopOpacity="0" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                    <stop offset="1" stopColor="white" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
